<template>
    <router-view />
</template>

<style scoped>

</style>

<script>
export default {
    name: "Options",
};
</script>
